
import { Component } from '@angular/core';
import { SiriusBaseComponent } from 'sirius-framework';
import { Router } from '@angular/router';

@Component({
    selector: 'redirect',
    template: ` `,
})
export class RedirectComponent extends SiriusBaseComponent<any> {
    constructor(private router: Router) {
        super();
    }
    OnInit() {
        //State yapisi kurulduktan sonra, GetInnerMenuSidebarItems
        //servisini stateden cekerek,start transaction cagirimlarina
        //parametre olarak itemlarin redirecttransaction degerini ver
        switch (this.router.url) {
            case '/inner-menu/sales':
                this.startTransaction('SalesIndividualTransaction');
                break;
            case '/inner-menu/buy':
                this.startTransaction('BuyTransaction');
                break;
            case '/inner-menu/liveprocess':
                this.startTransaction('LiveProcessTransaction');
                break;
            case '/inner-menu/oldprocess':
                this.startTransaction('OldProcessTransaction');
                break;
            case '/inner-menu/account':
                this.startTransaction('AccountProfileTransaction');
                break;
        }
    }    
}
